module.exports = "data:image/gif;base64,R0lGODlhEAAQAMQRADpWjvTy9aJhZUJCQs+uroify8fM1s/a77W5wlp5uerb3bmPnH19fYo+OK15eN/l7wAAAP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAABEALAAAAAAQABAAAAViYBQFSSCeIoRGRVKs6ZokAByp55E8gAHjolkBkPidSCYD4LECDhEBALFpqwIji+xCQKCeHCNBw3jENronBgKCYJwUDTDKAKkjvg2TAjWADE4EZyNyInR3EXBxDnErblWPESEAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu_icons/sortazlang.gif
// module id = JLGX
// module chunks = 1